import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { DropdownButton } from 'react-bootstrap';
import FormSelectIcon from 'mdi-react/FormSelectIcon';
import styles from './TripColumnsMultiSelect.module.scss';

type Props = {
  columnNames: [string, string][];
  initSelectedColumns?: string[];
  onFilterColumnsChange: (column: string, isChecked: boolean) => void;
};

const TripColumnsMultiSelect: React.FC<Props> = ({ onFilterColumnsChange, columnNames, initSelectedColumns }) => {
  const [countSelected, setCountSelected] = useState<number>(
    columnNames.filter((x) => initSelectedColumns?.includes(x[0]))?.length,
  );

  const handleCheckBoxChange = (e: CheckboxChangeEvent) => {
    if (e.target.name) {
      onFilterColumnsChange(e.target.name, e.target.checked);
      if (e.target.checked) {
        setCountSelected(countSelected + 1);
      } else {
        setCountSelected(countSelected - 1);
      }
    }
  };

  useEffect(() => {
    setCountSelected(columnNames.filter((x) => initSelectedColumns?.includes(x[0]))?.length);
  }, [columnNames]);

  return (
    <DropdownButton
      className={styles.fieldsDropdown}
      variant="outline-secondary"
      title={
        <FormSelectIcon
          size={22}
          className={countSelected ? styles.fieldsDropdownIconFlashed : styles.fieldsDropdownIcon}
        />
      }
    >
      {columnNames.map((c) => (
        <p key={c[0]}>
          <Checkbox
            name={c[0]}
            checked={initSelectedColumns?.includes(c[0])}
            onChange={handleCheckBoxChange}
            className={classNames('ml-2 p-0')}
          >
            {c[1]}
          </Checkbox>
        </p>
      ))}
    </DropdownButton>
  );
};

export default TripColumnsMultiSelect;
